import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { MLoader } from '../components/molecules';
import {
	OUserInfo,
	ODestructiveButtons,
} from '../components/organisme';

import { CMS_CONFIG } from '../config/cms.config';
import { setCmsHead } from '../redux/head/headActions';
import store from '../redux/store/store';
import { updateForm, addUser, removeUser, initForm } from '../redux/cms/cmsActions';
import withAuthGuard from '../helpers/withAuthGuard';

const mapStateToProps = state => ({
	username: get(state, 'cms.form.username.value', ''),
	password: get(state, 'cms.form.password.value', ''),
	isValid: state.cms.isFormValid,
	isUploading: state.cms.isUploading,
	uploadingFailed: state.cms.uploadingFailed,
});

class CreateUserPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			username: '',
			password: '',
			isValid: false,
			isUploading: false,
			uploadingFailed: false,
			isEditMode: false,
		};

		this.bindHandles();
	}

	componentDidMount() {
		const editMode = this.checkForEditMode();
		this.props.setCmsHead({ ...CMS_CONFIG.USERS.header.create });
		this.initForm({ editMode });
	}

	componentWillReceiveProps(props) {
		for (const key in this.state) {
			if (key in props && props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		}
	}

	checkForEditMode() {
		const isEditMode = 'slug' in this.props.match.params;

		this.setState({ isEditMode });

		return isEditMode;
	}

	initForm({ editMode = false }) {
		let values = {};

		if (editMode) {
			values = store.getState().content.users.find(item => item.uuid === this.props.match.params.slug);
		}

		this.props.initForm({
			fields: CMS_CONFIG.CREATE.user,
			values,
		});
	}

	bindHandles() {
		this.handleFieldChange = this.handleFieldChange.bind(this);
		this.handleSave = this.handleSave.bind(this);
	}

	handleFieldChange({ field, value, error }) {
		this.props.updateForm({ key: field, value, valid: !error });
	}

	handleSave(event) {
		if (event) {
			event.preventDefault();
		}

		if (!this.state.isValid) {
			return;
		}

		this.props.addUser(this.props.history);
	}

	handleRemove() {
		const uuid = '';
		this.props.removeUser(uuid);
	}

	render() {
		let content;

		if (this.state.isUploading) {
			content = <MLoader className="article--loader article--loader-create" />;
		}

		return (
			<div className="layout-cms--wrapper">
				<form noValidate onSubmit={this.handleSave}>
					<div className="layout-cms--content-body--create">
						<OUserInfo
							email={this.state.username}
							password={this.state.password}
							onEmailChange={(value, error) => this.handleFieldChange({ field: 'username', value, error })}
							onPasswordChange={(value, error) => this.handleFieldChange({ field: 'password', value, error })}
						/>
					</div>
					<div className="section-cms--destructive-buttons">
						<ODestructiveButtons
							onSave={this.handleSave}
							saveEnabled={this.state.isValid}
							showDelete={this.state.isEditMode}
						/>
					</div>
					{content}
				</form>
			</div>
		);
	}
}

CreateUserPage.propTypes = {
	setCmsHead: PropTypes.func.isRequired,
	updateForm: PropTypes.func.isRequired,
	addUser: PropTypes.func.isRequired,
	initForm: PropTypes.func.isRequired,
	removeUser: PropTypes.func.isRequired,
};

export default withAuthGuard(withRouter(connect(mapStateToProps, {
	setCmsHead,
	updateForm,
	addUser,
	initForm,
	removeUser,
})(CreateUserPage)));



// WEBPACK FOOTER //
// ./src/CMS/create-user.js